const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export default function formatDate(dateString) {
  // Convert Date string to JS Date format
  const d = new Date(dateString)

  // Get individual values
  const day = d.getDate()
  const month = months[d.getMonth()]
  const year = d.getFullYear()
  let hours = d.getHours()
  let minutes = d.getMinutes()

  // Fix hours and minutes format, so it looks like HH:SS (always double digit)
  if (hours < 10) {
    hours = "0" + hours
  }
  if (minutes < 10) {
    minutes = "0" + minutes
  }

  // Create formatted date string
  const formattedDate = `${month} ${day}, ${year} ${hours}:${minutes}`
  return formattedDate
}
